<!-- Button.svelte -->

<script>
	export let label = "";
	export let variant = "primary"; // "primary" | "danger" | "button-light" | "secondary"
	export let handleClick;
	export let disabled = false;
	export let type = "button";
</script>

<button
	{type}
	class="btn btn--{variant}"
	class:btn--disabled={disabled}
	{disabled}
	on:click={handleClick}
>
	<slot>{label}</slot>
</button>

<style>
	.btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		font-family: var(--font-sans);
		font-weight: 600;
		font-size: 14px;
		line-height: 1;
		padding: 10px 20px;
		border: 1.5px solid transparent;
		border-radius: var(--radius-md, 10px);
		cursor: pointer;
		white-space: nowrap;
		transition:
			background-color 0.15s ease,
			border-color 0.15s ease,
			color 0.15s ease,
			transform 0.1s ease,
			box-shadow 0.15s ease;
		user-select: none;
	}

	.btn:active:not(.btn--disabled) {
		transform: scale(0.97);
	}

	/* ── Variante: Primary (laranja MataFome) ── */
	.btn--primary {
		background-color: var(--brand-primary, #FF6A00);
		border-color: var(--brand-primary, #FF6A00);
		color: #ffffff;
	}
	.btn--primary:hover:not(.btn--disabled) {
		background-color: var(--brand-primary-hover, #E85A00);
		border-color: var(--brand-primary-hover, #E85A00);
		box-shadow: 0 2px 8px rgba(255, 106, 0, 0.35);
	}

	/* ── Variante: Danger (vermelho) ── */
	.btn--danger {
		background-color: var(--semantic-danger, #DC2626);
		border-color: var(--semantic-danger, #DC2626);
		color: #ffffff;
	}
	.btn--danger:hover:not(.btn--disabled) {
		background-color: #b91c1c;
		border-color: #b91c1c;
		box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
	}

	/* ── Variante: Button-light (cinza neutro) ── */
	.btn--button-light {
		background-color: var(--neutral-surface-hover, #F1F5F9);
		border-color: var(--neutral-border, #E2E8F0);
		color: var(--text-secondary, #475569);
	}
	.btn--button-light:hover:not(.btn--disabled) {
		background-color: var(--neutral-border, #E2E8F0);
		color: var(--text-primary, #0F172A);
	}

	/* ── Variante: Secondary ── */
	.btn--secondary {
		background-color: transparent;
		border-color: var(--neutral-border, #E2E8F0);
		color: var(--text-secondary, #475569);
	}
	.btn--secondary:hover:not(.btn--disabled) {
		background-color: var(--neutral-surface-hover, #F1F5F9);
		color: var(--text-primary, #0F172A);
	}

	/* ── Estado Desabilitado ── */
	.btn--disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}
</style>

